import { render } from "./notFoundPage.vue?vue&type=template&id=5aa787d7&scoped=true"
const script = {}

import "./notFoundPage.vue?vue&type=style&index=0&id=5aa787d7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa787d7"]])

export default __exports__